import React from 'react';
import { BIG_THREE, ROLES, blendLine } from '../../data/astro/bigThree';
import { SIGN_BY_NAME } from '../../data/astro/signs';

const ORDERS = {
  rising: ['Ascendant', 'Sun', 'Moon'],
  moon: ['Moon', 'Sun', 'Ascendant'],
};

const BigThree = ({ placements, timeUnknown, moonChange, variant }) => {
  const byLabel = Object.fromEntries((placements || []).map((item) => [item.label, item]));
  const order = ORDERS[variant] || ['Sun', 'Moon', 'Ascendant'];
  const sun = SIGN_BY_NAME[byLabel.Sun?.sign];
  const moon = SIGN_BY_NAME[byLabel.Moon?.sign];
  const rising = timeUnknown ? null : SIGN_BY_NAME[byLabel.Ascendant?.sign];

  return (
    <div className="big-three">
      <div className="big-three-cards">
        {order.map((role) => {
          const placement = byLabel[role];
          const info = ROLES[role];
          if (role === 'Ascendant' && (timeUnknown || !placement)) {
            return (
              <article key={role} className="big-three-card missing">
                <p className="big-three-role">{info.title} · {info.governs}</p>
                <h3>Rising sign needs a birth time</h3>
                <p>
                  The rising sign changes about every two hours, so it can't be found from the date alone. If you can
                  find your birth time (a birth certificate or a parent often has it), edit the chart to add it.
                </p>
              </article>
            );
          }
          if (!placement) return null;
          const sign = SIGN_BY_NAME[placement.sign];
          const changed = role === 'Moon' && moonChange;
          return (
            <article key={role} className={`big-three-card element-${sign?.element || 'none'}`}>
              <p className="big-three-role">{info.title} · {info.governs}</p>
              <h3>
                <span className="big-three-glyph" aria-hidden="true">{sign?.glyph}</span>
                {changed ? `${moonChange.from} or ${moonChange.to} ${info.title}` : `${placement.sign} ${info.title}`}
              </h3>
              <p className="big-three-meta">
                {changed ? 'Changed signs on your birthday' : placement.degree}
                {placement.house ? ` · House ${placement.house}` : ''}
              </p>
              {changed ? (
                <>
                  <p>
                    The Moon moved from {moonChange.from} into {moonChange.to} on the day you were born. Your birth time
                    decides which one is yours.
                  </p>
                  <p><strong>{moonChange.from}:</strong> {BIG_THREE.Moon[moonChange.from]}</p>
                  <p><strong>{moonChange.to}:</strong> {BIG_THREE.Moon[moonChange.to]}</p>
                </>
              ) : (
                <p>{BIG_THREE[role]?.[placement.sign]}</p>
              )}
            </article>
          );
        })}
      </div>
      {sun && moon && !moonChange && <p className="big-three-blend">{blendLine(sun, moon, rising)}</p>}
    </div>
  );
};

export default BigThree;
